var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.user_info.dirty && _vm.user_info.data.space_id)?_c('TheOffice'):(!_vm.user_info.dirty)?_c('TheIntro'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }